<template>
<div class="container-fluid">
    <div
        class="herosection"
        :style="{
            backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '924px'
        }"
        >
        <NavbarSection />
        <!-- <img src="../assets/images/forms/bgOverlay.png" alt="overlay" class="overlay-img" /> -->
        <div class="heroWriteup">
            <h2>Forms and Applications</h2>
            <p>Welcome to the LLTC membership application process. Below you'll find all the necessary forms,
                information, and payment options to begin your journey as a member of our exclusive club. Please review
                all materials carefully and complete the required documentation.</p>
        </div>
    </div>
    <div class="card" v-if="dataList2">
        <p v-html="dataList2"></p>
        <button>
            <a :href="brochureFile" target="_blank">Download PDF</a>
            <FileText />
        </button>
    </div>
    <div class="card" v-if="dataList">
        <p v-html="dataList"></p>
        <button>
            <a :href="documentFile" target="_blank">Download PDF</a>
            <FileText />
        </button>
    </div>
    <div class="card last">
        <h2>Online Application Form</h2>
        <p>Easily complete and submit your membership application online at your convenience.</p>
        <button @click="applyNow">
            <p>Apply Now</p>
            <ArrowRight />
        </button>
    </div>
    <FooterSection />
</div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import { FileText, ArrowRight } from 'lucide-vue-next';
import router from "@/router";
import axios from 'axios';
import { ref, nextTick, onMounted } from 'vue';

let base_url = process.env.VUE_APP_BASE_LIVE_URL

const dataList = ref('');
const dataList2 = ref('');
let documentFile = ref('');
let brochureFile = ref('');

const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');

//methods
onMounted( async () => {
  
  await listDocument();
  await listBrochure();
  await listBanner()
 
  await nextTick();
  window.scrollTo({ top: 0 });
});

const listBanner = async () => {
  try {
    const config = 'application-form';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listDocument = async () => {
  try {
    const response = await axios.get('/document_list.php', { });
    const documentData = response.data.data[0];
    dataList.value = documentData.title
    documentFile.value = `${base_url}${documentData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listBrochure = async () => {
  try {
    const response = await axios.get('/brochure_list.php', { });
   const brochureData = response.data.data[0];
   dataList2.value = brochureData.title
   brochureFile.value = `${base_url}${brochureData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const applyNow = () => {
    router.push("/register")
}

</script>

<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/forms/main-image.jpg');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}

/* Dark overlay */
.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Adjust opacity for darkness */
    z-index: 1;
    /* sits above images but below content */
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    /* stays behind overlay */
}

.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}

.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: left;
    bottom: 5%;
    left: 25%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;
    padding: 0 0 0 50px !important;


    h2 {
        font-size: 52px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: left;
    }

    p {
        font-size: 18px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: left;
        
    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    /* make it cover */
    height: 100%;
    object-fit: cover;
    /* prevent distortion */
    opacity: 0.6;
    /* control transparency */
}

.card {
    max-width: 80%;
    margin: 2rem auto;
    height: 309px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #ffffff;
    border-radius: 24px;
    border: 1px solid #00000033;
    padding: 40px 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    h2 {
        font-size: 24px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;
    }

    p {
        font-size: 15px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;
    }

    button {
        background-color: #fff;
        border: 2px solid #0000001f;
        color: #000000;
        border-radius: 60px;
        width: 100%;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-top: 2rem;

        a {
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            font-weight: 500;
            margin: 0%;
            color: #000000;
            padding: 0%;
            padding: 15px 25px;
        }
    }
}

.last {
    max-width: 80%;
    margin: 2rem auto;
    height: 309px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #094923;
    border-radius: 24px;
    border: 1px solid #00000033;
    padding: 40px 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    h2 {
        font-size: 24px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;
        color: #fff;
    }

    p {
        font-size: 20px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;
        color: #FFFFFF99;
    }

    button {
        background-color: #ED4E24;
        border: 2px solid #0000001f;
        color: #fff;
        border-radius: 60px;
        width: 100%;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-top: 2rem;

        p {
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            font-weight: 500;
            margin: 0%;
            color: #fff;
            padding: 0%;
            padding: 15px 25px;
        }
    }
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;
        padding: 0 10px 0 10px !important;

        h2 {
            font-size: 20px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }

    .card {
        max-width: 100%;
        margin: 1rem auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        background-color: #ffffff;
        border-radius: 24px;
        border: 1px solid #00000033;
        padding: 10px 20px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        h2 {
            font-size: 18px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }

        button {
            background-color: #fff;
            border: 2px solid #0000001f;
            color: #000000;
            border-radius: 60px;
            width: 100%;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: 2rem;

            p {
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                font-weight: 500;
                margin: 0%;
                color: #000000;
                padding: 0%;
                padding: 15px 25px;
            }
        }
    }

    .last {
        max-width: 100%;
        margin: 1rem auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        background-color: #094923;
        border-radius: 24px;
        border: 1px solid #00000033;
        padding: 10px 20px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        h2 {
            font-size: 18px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: left;
            color: #fff;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
            color: #FFFFFF99;
        }

        button {
            background-color: #ED4E24;
            border: 2px solid #0000001f;
            color: #fff;
            border-radius: 60px;
            width: 100%;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: 2rem;

            p {
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                font-weight: 500;
                margin: 0%;
                color: #fff;
                padding: 0%;
                padding: 15px 25px;
            }
        }
    }
}
</style>
